__turbopack_context__.v({
  "blocksBackgroundColor": "PrivateLogin-module-scss-module__42JJZW__blocksBackgroundColor",
  "blocksFontColor": "PrivateLogin-module-scss-module__42JJZW__blocksFontColor",
  "container": "PrivateLogin-module-scss-module__42JJZW__container",
  "containerTerrace": "PrivateLogin-module-scss-module__42JJZW__containerTerrace",
  "secondaryNavBackgroundColor": "PrivateLogin-module-scss-module__42JJZW__secondaryNavBackgroundColor",
  "themeBackgroundColor": "PrivateLogin-module-scss-module__42JJZW__themeBackgroundColor",
  "themeFontColor": "PrivateLogin-module-scss-module__42JJZW__themeFontColor",
  "warning": "PrivateLogin-module-scss-module__42JJZW__warning",
});
